import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { UIComponentView } from '../uicomponentview';
import { HorizontalListViewImpl } from './horizontallistview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { HorizontalListCSSStyleImpl } from './horizontallistcss';
import { ListViewModel } from './listviewmodel';
import { BaseContext } from '../../../utils/basecontext';

export enum MarginTopType
{
    CATEGORY = "0px",
    MULTISELECT_CATEGORY = "-12px",
    TONE = "-30px"
}

export enum ArrowsType
{
    CATEGORY = "",
    MULTISELECT_CATEGORY = "",
    TONE = "",
    TONE_CARD= "_black"
}

export enum GutterType
{
    CATEGORY = "20px",
    MULTISELECT_CATEGORY = "10px",
    TONE = "20px"
}

export enum ArrowsSizeType
{
    CATEGORY = "28px",
    MULTISELECT_CATEGORY = "18px",
    TONE = "28px"
}

export enum ArrowsPaddingType
{
    CATEGORY = "15px",
    MULTISELECT_CATEGORY = "-10px",
    TONE = "15px"
}

export interface HorizontalListComponentProps<T> extends UIComponentProps
{
    title: string;
    listViewModel: ListViewModel<T>;
    gutterType: GutterType;
    arrowsSizeType: ArrowsSizeType;
    arrowsPaddingType: ArrowsPaddingType;
    marginTopType: MarginTopType;
    arrowsType?:ArrowsType;
}

export class HorizontalListComponent<T> extends UIComponentImpl<HorizontalListComponentProps<T>,
 UIComponentState, UIDataModel> 
{
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new HorizontalListViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new HorizontalListCSSStyleImpl(applicationContext);
    }


        // this.props.loadMore(this.state.startIndex, this.state.offset);
        // this.setState((currState: HorizontalListComponentState<T>)=>
        //     {
        //     let nextPageContents = this.getNextPage(currState.lastPage + 1);
        
        //     return {listOfDatas: [...currState.listOfDatas, ...nextPageContents], lastPage: currState.lastPage + 1};
        // });

    // private getNextPage(pageNumber: number): T[]
    // {
    //     if(pageNumber >=5)
    //     {
    //         return [];
    //     }

    //     let array:T[] = [];
    //     for(let i = (pageNumber-1)*7; i<(pageNumber-1)*7+7; i++)
    //     {
    //         let item = this.props.listViewModel.getItem(i);

    //         array.push(item);
    //     }
    //     return array;
    // }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/horizontallist/horizontallistcomponent.tsx